module.exports = __webpack_public_path__ + "img/switch.cf4b9acb.svg";